import { Controller } from "@hotwired/stimulus"

// Esconde campos PF (Dados Pessoais, Data de Nascimento) quando o documento
// digitado tem 14 dígitos (CNPJ). Pessoa Jurídica não tem RG/sexo/estado
// civil/profissão/nascimento aplicáveis. Quando esconde, remove o atributo
// `required` dos inputs internos pra não bloquear submit HTML5.
export default class extends Controller {
  static targets = ["documentInput", "pfSection"]

  connect() {
    this.toggle()
  }

  toggle() {
    const digits = this.documentInputTarget.value.replace(/\D/g, "")
    const isPj = digits.length === 14

    this.pfSectionTargets.forEach(section => {
      section.classList.toggle("hidden", isPj)
      section.querySelectorAll("input, select, textarea").forEach(field => {
        if (isPj) {
          if (field.required) {
            field.dataset.wasRequired = "true"
            field.required = false
          }
        } else if (field.dataset.wasRequired === "true") {
          field.required = true
          delete field.dataset.wasRequired
        }
      })
    })
  }
}
